import { gql } from "graphql-request";

export const CREATE_USER_MUTATION = gql`mutation createUser ($mutationFields: [String!], $mutationValues: [String!]){
  createUser(input: {mutationFields: $mutationFields, mutationValues: $mutationValues}) {
    message
    statusCode
  }
}
`;